;(() => {
  function addCartPageFormEventListeners() {
    customInputNumberListeners(
      document.querySelector('section#template-cart form[action="/cart"]')
    )

    //update quanity when value is changed
    document
      .querySelectorAll(
        'section#template-cart form[action="/cart"] .input-number-wrapper input'
      )
      .forEach((input) => {
        input.addEventListener('change', async function () {
          const key = input
            .closest('[data-item-key]')
            .getAttribute('data-item-key')
          updateCartPageQuantityDebounced(key, this.value) //debounce call to update with API
        })
      })
  }

  if (document.querySelector('section#template-cart form[action="/cart"]')) {
    addCartPageFormEventListeners() //init on first page load
  }

  async function updateCartPageQuantity(key, quantity) {
    const res = await fetch('/cart/update.js', {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates: { [key]: quantity } })
    })

    updateCartPage()

    const cart = await res.json()
    updateHeaderCartCount(cart.item_count)
  }

  const updateCartPageQuantityDebounced = debounce((productKey, quantity) =>
    updateCartPageQuantity(productKey, quantity)
  )

  async function updateCartPage() {
    const res = await fetch('/?section_id=main-cart') //get section again that will contain the updated values
    const text = await res.text()

    //convert plain text to html
    const html = document.createElement('div')
    html.innerHTML = text

    const updatedCart = html.querySelector('.cart-page-form').innerHTML
    document.querySelector('.cart-page-form').innerHTML = updatedCart
    addCartPageFormEventListeners() //re-add event listeners once html has been replaced
  }
})()
